module.exports = __webpack_public_path__ + "static/img/home_shoucang.2d54f95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home_shoucang.png
// module id = 8W+r
// module chunks = 1